export default __webpack_public_path__ + "static/media/empty.0a2164b0.svg";